"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api_service = void 0;
var axios_1 = require("axios");
var jwt_decode_1 = require("jwt-decode");
var react_hot_toast_1 = require("react-hot-toast");
var ToastPosition = require("react-toastify");
var universal_cookie_1 = require("universal-cookie");
var uuid_1 = require("uuid");
var actions_1 = require("../actions");
var config_action_1 = require("../actions/config_action");
var user_action_1 = require("../actions/user_action");
var app_config_1 = require("../config/app_config");
var appConstants_1 = require("../constants/appConstants");
var index_1 = require("../store/index");
var lodash_1 = require("./../utils/lodash");
var api_urls_1 = require("./api_urls");
var query_string_1 = require("query-string");
var cryptoService_1 = require("./cryptoService");
var cookies = new universal_cookie_1.default();
var APIService = (function () {
    function APIService() {
        var _this = this;
        this.api_urls = api_urls_1.api_urls;
        this.axiosOptions = {
            timeout: 30000,
            withCredentials: true,
        };
        this.ContentHeaders = {
            Json: 'application/json',
            FormData: 'multipart/form-data',
            Plain: 'text/plain',
        };
        this.BaseDomain = {
            BASE: process.env.VENDOR_BASE_URL,
            APP_ID: process.env.APP_ID,
            DEVICE_TYPE: process.env.DEVICE_TYPE,
            APP_VERSION: process.env.APP_VERSION,
            SECRET_KEY: process.env.SECRET_KEY,
            CLIENT_REVIEW_DOMAIN: process.env.CLIENT_REVIEW_DOMAIN,
            SIGNATURE_VERSION: process.env.SIGNATURE_VERSION,
        };
        this.isNotificationCall = false;
        this.noOfRequests = 0;
        this.getSortedPayload = function (unOrderedPayload) {
            if (unOrderedPayload === null || unOrderedPayload === void 0 ? void 0 : unOrderedPayload.attributes) {
                var orderedPayload = Object.keys(unOrderedPayload.attributes).sort().reduce(function (obj, key) {
                    obj[key] = unOrderedPayload.attributes[key];
                    return obj;
                }, {});
                if (Object.keys(orderedPayload).length > 0) {
                    return { attributes: __assign({}, orderedPayload) };
                }
                else {
                    return {};
                }
            }
            else {
                var orderedPayload = Object.keys(unOrderedPayload).sort().reduce(function (obj, key) {
                    obj[key] = unOrderedPayload[key];
                    return obj;
                }, {});
                return orderedPayload;
            }
        };
        this.getSignatureUniqueKey = function (data) {
            var _a, _b;
            if (((_a = process.env.SIGNATURE_VERSION) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'V3' ||
                ((_b = process.env.SIGNATURE_VERSION) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'V2') {
                if (data.authorization) {
                    var decoded = (0, jwt_decode_1.jwtDecode)(data.authorization);
                    return (decoded === null || decoded === void 0 ? void 0 : decoded.uniqueId) || '';
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        };
        this.post = function (data) {
            if (!data.domain) {
                data.domain = _this.BaseDomain.BASE;
            }
            if (!data.headerType) {
                data.headerType = _this.ContentHeaders.Json;
            }
            if (data.showLoader != false) {
                data.showLoader = true;
            }
            if (!data.useNonInterceptor) {
                data.useNonInterceptor = false;
            }
            if (data.showLoader) {
                index_1.store.dispatch(actions_1.default.loader_Actions.showLoader(data.showLoader));
            }
            if (data.useNonInterceptor) {
                var payLoadData = data.payLoad instanceof FormData
                    ? data.payLoad
                    : JSON.stringify(data.payLoad);
                return _this.axiosNoInterceptor.post(data.endPoint, payLoadData, {
                    timeout: _this.axiosOptions.timeout,
                    transformRequest: _this.axiosOptions.transformRequest,
                    baseURL: data.domain,
                    headers: _this.getHeadersByType(data.headerType, data.domain, data.customHeaders),
                });
            }
            else {
                var payLoadData = data.payLoad instanceof FormData
                    ? data.payLoad
                    : JSON.stringify(data.payLoad);
                return axios_1.default.post(data.endPoint, payLoadData, {
                    timeout: _this.axiosOptions.timeout,
                    transformRequest: _this.axiosOptions.transformRequest,
                    baseURL: data.domain,
                    headers: _this.getHeadersByType('post', data.headerType, data.domain, data.customHeaders, data.payLoad),
                });
            }
        };
        this.isNetworkError = function (error) {
            return !error.response && error.code !== 'ECONNABORTED';
        };
        this.retry = function (config) {
            return (0, axios_1.default)(config);
        };
        this.put = function (data) {
            if (!data.domain) {
                data.domain = _this.BaseDomain.BASE;
            }
            if (!data.headerType) {
                data.headerType = _this.ContentHeaders.Json;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                index_1.store.dispatch(actions_1.default.loader_Actions.showLoader(data.showLoader));
            }
            var payLoadData = data.payLoad instanceof FormData
                ? data.payLoad
                : JSON.stringify(data.payLoad);
            return axios_1.default.put(data.endPoint, payLoadData, {
                timeout: _this.axiosOptions.timeout,
                transformRequest: _this.axiosOptions.transformRequest,
                baseURL: data.domain,
                headers: _this.getHeadersByType('put', data.headerType, data.domain, data.customHeaders, data.payLoad),
            });
        };
        this.delete = function (data) {
            if (!data.domain) {
                data.domain = _this.BaseDomain.BASE;
            }
            if (!data.headerType) {
                data.headerType = _this.ContentHeaders.Json;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                index_1.store.dispatch(actions_1.default.loader_Actions.showLoader(data.showLoader));
            }
            return axios_1.default.delete(data.endPoint, {
                baseURL: data.domain,
                headers: _this.getHeadersByType('delete', data.headerType, data.domain, data.customHeaders),
            });
        };
        this.get = function (data) {
            if (!data.domain) {
                data.domain = _this.BaseDomain.BASE;
            }
            if (!data.headerType) {
                data.headerType = _this.ContentHeaders.Json;
            }
            if (data.showLoader || data.showLoader === undefined) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                index_1.store.dispatch(actions_1.default.loader_Actions.showLoader(data.showLoader));
            }
            try {
                return axios_1.default.get(data.endPoint, {
                    baseURL: data.domain,
                    timeout: _this.axiosOptions.timeout,
                    params: data.payLoad,
                    headers: _this.getHeadersByType('delete', data.headerType, data.domain, data.customHeaders),
                });
            }
            catch (e) {
                console.error('axios get::', e);
            }
        };
        this.uploadFile = function (data) {
            if (!data.domain) {
                data.domain = _this.BaseDomain.BASE;
            }
            if (!data.headerType) {
                data.headerType = _this.ContentHeaders.Json;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (!data.useNonInterceptor) {
                data.useNonInterceptor = false;
            }
            if (data.useNonInterceptor) {
                var payLoadData = data.payLoad instanceof FormData
                    ? data.payLoad
                    : JSON.stringify(data.payLoad);
                return _this.axiosNoInterceptor.post(data.endPoint, payLoadData, {
                    timeout: _this.axiosOptions.timeout,
                    transformRequest: _this.axiosOptions.transformRequest,
                    baseURL: data.domain,
                    headers: _this.getHeadersByType('post', data.headerType, data.domain, data.customHeaders, data.payLoad),
                });
            }
            else {
                var payLoadData = data.payLoad instanceof FormData
                    ? data.payLoad
                    : JSON.stringify(data.payLoad);
                return axios_1.default.post(data.endPoint, payLoadData, {
                    timeout: _this.axiosOptions.timeout,
                    transformRequest: _this.axiosOptions.transformRequest,
                    baseURL: data.domain,
                    headers: _this.getHeadersByType('post', data.headerType, data.domain, data.customHeaders, data.payLoad),
                });
            }
        };
        this.axiosNoInterceptor = axios_1.default.create();
        axios_1.default.interceptors.request.use(function (request) { return __awaiter(_this, void 0, void 0, function () {
            var externalDomains, isExternalAPI, parameters, urlArray, routeParams, payloadData, _i, _a, _b, key, value, signatureData, error_1;
            var _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _h.trys.push([0, 3, , 4]);
                        externalDomains = [
                            'autosuggest.search.hereapi.com',
                            'api.here.com',
                            'js.api.here.com',
                            'search.hereapi.com',
                        ].filter(Boolean);
                        isExternalAPI = externalDomains.some(function (domain) { return request.url.includes(domain); });
                        parameters = undefined;
                        if (request.params) {
                            parameters = request.params;
                        }
                        urlArray = request.url.split('?');
                        if (urlArray && urlArray.length > 1) {
                            routeParams = query_string_1.default.parse(urlArray[1]);
                            parameters = routeParams;
                        }
                        payloadData = {};
                        if (((_c = request.headers) === null || _c === void 0 ? void 0 : _c['Content-Type']) && ((_d = request.headers) === null || _d === void 0 ? void 0 : _d['Content-Type']) === 'multipart/form-data') {
                            try {
                                for (_i = 0, _a = request.data.entries(); _i < _a.length; _i++) {
                                    _b = _a[_i], key = _b[0], value = _b[1];
                                    if (key === 'file' && value instanceof File) {
                                        payloadData[key] = value.name;
                                    }
                                    else {
                                        payloadData[key] = value;
                                    }
                                }
                            }
                            catch (error) {
                                console.log('Error----::', error);
                            }
                        }
                        else {
                            payloadData = (request.data && request.data !== undefined && request.data !== null) ? JSON.parse(request.data) : {};
                        }
                        if (!!isExternalAPI) return [3, 2];
                        return [4, this.generateSignature({ authorization: (_e = request.headers) === null || _e === void 0 ? void 0 : _e['x-auth-token'], payload: payloadData, params: parameters })];
                    case 1:
                        signatureData = _h.sent();
                        if (signatureData) {
                            request.headers['x-signature'] = signatureData.signature;
                            request.headers['x-nonce'] = signatureData.nonce;
                        }
                        if (((_f = process.env.SIGNATURE_VERSION) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === 'V2' ||
                            ((_g = process.env.SIGNATURE_VERSION) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === 'V3') {
                            request.headers['x-signature-version'] = process.env.SIGNATURE_VERSION;
                        }
                        _h.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        error_1 = _h.sent();
                        console.log('axios tryCatch error----------::', error_1);
                        return [3, 4];
                    case 4:
                        this.incrementRequestCount();
                        return [2, request];
                }
            });
        }); }, function (error) {
            return _this.requestPromise(error);
        });
        axios_1.default.interceptors.response.use(function (response) {
            _this.decrementRequestCount();
            if (response.status === 200) {
            }
            return response;
        }, function (error) {
            var _a, _b, _c, _d;
            _this.decrementRequestCount();
            if (error.response) {
                if (error.response.status === 403) {
                    exports.api_service
                        .post({
                        endPoint: api_urls_1.api_urls.REFRESH_TOKEN,
                        payLoad: cookies.get('cookies_refresh_token'),
                        showLoader: true,
                        domain: process.env.AUTHENTICATION_SERVER_URL,
                    })
                        .then(function (res) {
                        if (res.data.status === 200) {
                            index_1.store.dispatch(user_action_1.default.setLoginStatus({
                                loginStatus: true,
                            }));
                            var decoded_token = (0, jwt_decode_1.jwtDecode)(res.data.data.token);
                            var decoded_refresh_token = (0, jwt_decode_1.jwtDecode)(res.data.data.refreshToken);
                            cookies.set('cookies_jwt_token', res.data.data.token, {
                                expires: new Date(decoded_token.exp * 1000),
                                secure: true,
                                httpOnly: false,
                                sameSite: true,
                            });
                            cookies.set('cookies_refresh_token', res.data.data.refreshToken, {
                                expires: new Date(decoded_refresh_token.exp * 1000),
                                secure: true,
                                httpOnly: false,
                                sameSite: true,
                            });
                        }
                    })
                        .catch(function (err) {
                        react_hot_toast_1.default.error('Session expired. please re-login to continue!');
                    });
                    return error.response;
                }
                if (error.response.status === 406) {
                    var erroMessageRes = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                    var staticErr = 'Session expired. please re-login to continue!';
                    var errorMessage = erroMessageRes ? erroMessageRes : staticErr;
                    react_hot_toast_1.default.error(errorMessage, {
                        duration: 10 * 1000,
                        position: ToastPosition.toast.POSITION.TOP_RIGHT,
                    });
                    index_1.store.dispatch(user_action_1.default.setLoginStatus({
                        loginStatus: false,
                        sessionExpired: true,
                    }));
                    cookies.remove('cookies_jwt_token');
                    cookies.remove('cookies_refresh_token');
                    index_1.store.dispatch((0, config_action_1.featchCurrentActiveMenu)({
                        mainModule: '',
                        subModule: '',
                        subChaildModule: '',
                        subGroupModule: ''
                    }));
                    window.location.replace('/');
                    return error.response;
                }
                if (error.response.status === 409 || error.response.status === 401) {
                    if (!cookies.get('cookies_jwt_token')) {
                        var errorMessage = error.response.data.message == 'Sorry! Authentication token is missing' ? 'Session expired. please re-login to continue!' : error.response.data.message;
                        if (error.response.data.message == 'Sorry! Authentication token is missing') {
                            react_hot_toast_1.default.error(errorMessage, {
                                duration: 10 * 1000,
                                position: ToastPosition.toast.POSITION.TOP_RIGHT,
                            });
                            index_1.store.dispatch(user_action_1.default.setLoginStatus({
                                loginStatus: false,
                                sessionExpired: true,
                            }));
                            cookies.remove('cookies_jwt_token');
                            cookies.remove('cookies_refresh_token');
                            index_1.store.dispatch((0, config_action_1.featchCurrentActiveMenu)({
                                mainModule: '',
                                subModule: '',
                                subChaildModule: '',
                                subGroupModule: ''
                            }));
                            window.location.replace('/');
                        }
                    }
                    return error.response;
                }
                if (error.response.status === 400) {
                    if (!cookies.get('cookies_jwt_token') &&
                        appConstants_1.X_AUTH_TOKEN_REQUIRED == ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message)) {
                        var errorMessage = 'Session expired. please re-login to continue!';
                        react_hot_toast_1.default.error(errorMessage, {
                            duration: 10 * 1000,
                            position: ToastPosition.toast.POSITION.TOP_RIGHT,
                        });
                        index_1.store.dispatch(user_action_1.default.setLoginStatus({
                            loginStatus: false,
                            sessionExpired: true,
                        }));
                        cookies.remove('cookies_jwt_token');
                        cookies.remove('cookies_refresh_token');
                        index_1.store.dispatch((0, config_action_1.featchCurrentActiveMenu)({
                            mainModule: '',
                            subModule: '',
                            subChaildModule: '',
                            subGroupModule: ''
                        }));
                        window.location.replace('/');
                    }
                    return error.response;
                }
                if (error.response.status === 404) {
                    return error.response;
                }
                if (error.response.status === 500) {
                    return error.response;
                }
            }
            return _this.responsePromise(error);
        });
    }
    APIService.prototype.responsePromise = function (res) {
        return new Promise(function (resolve, reject) {
            if (res.response) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    };
    APIService.prototype.requestPromise = function (res) {
        return new Promise(function (resolve, reject) {
            if (res.response) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    };
    APIService.prototype.incrementRequestCount = function () {
        this.noOfRequests++;
    };
    APIService.prototype.decrementRequestCount = function () {
        this.noOfRequests--;
        if (this.noOfRequests === 0) {
            index_1.store.dispatch(actions_1.default.loader_Actions.showLoader(false));
        }
    };
    APIService.prototype.generateSignature = function (data) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var nonce, secretKey, apiData, sortedPayload, sortedParams_1, paramsKeys, finalObj_1, encodedSignature, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        nonce = (0, uuid_1.v4)();
                        secretKey = this.getSignatureUniqueKey(data);
                        apiData = '';
                        if (data.authorization) {
                            apiData = data.authorization;
                        }
                        apiData = apiData + secretKey + nonce;
                        if (((_a = process.env.SIGNATURE_VERSION) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'V2' ||
                            ((_b = process.env.SIGNATURE_VERSION) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'V3') {
                            if (data.payload && Object.keys(data.payload).length > 0) {
                                sortedPayload = this.getSortedPayload(data.payload);
                                if (Object.keys(sortedPayload).length > 0) {
                                    apiData += typeof data.payload === 'string' ? data.payload : JSON.stringify(sortedPayload);
                                }
                            }
                            if (data.params && Object.keys(data.params).length > 0) {
                                sortedParams_1 = this.getSortedPayload(data.params);
                                if (Object.keys(sortedParams_1).length > 0) {
                                    paramsKeys = Object.keys(sortedParams_1);
                                    finalObj_1 = {};
                                    __spreadArray([], paramsKeys, true).map(function (key) {
                                        var _a;
                                        finalObj_1[key] = (_a = sortedParams_1[key]) === null || _a === void 0 ? void 0 : _a.toString();
                                    });
                                    apiData += typeof data.params === 'string' ? data.params : JSON.stringify(finalObj_1);
                                }
                            }
                        }
                        else {
                            if (data.payload && Object.keys(data.payload).length > 0) {
                                apiData += typeof data.payload === 'string' ? data.payload : JSON.stringify(data.payload);
                            }
                        }
                        return [4, (0, cryptoService_1.getCryptoHash)(apiData)];
                    case 1:
                        encodedSignature = _c.sent();
                        return [2, {
                                signature: encodedSignature,
                                nonce: nonce,
                            }];
                    case 2:
                        error_2 = _c.sent();
                        return [2, error_2];
                    case 3: return [2];
                }
            });
        });
    };
    APIService.prototype.getHeadersByType = function (requestMethod, headerType, domain, customHeaders, payload) {
        var _a, _b;
        var data = {};
        switch (headerType) {
            case this.ContentHeaders.Json: {
                data['Content-Type'] = 'application/json';
                data['Accept'] = 'application/json';
                break;
            }
            case this.ContentHeaders.Plain: {
                data['Content-Type'] = 'text/plain';
                break;
            }
            case this.ContentHeaders.FormData: {
                data['Content-Type'] = 'multipart/form-data';
                break;
            }
            default:
                data['Content-Type'] = 'application/json';
                break;
        }
        data['x-source'] = app_config_1.appConfig.source;
        data['x-language'] = app_config_1.appConfig.lang;
        data['x-app-id'] = this.BaseDomain.APP_ID;
        data['x-device-type'] = this.BaseDomain.DEVICE_TYPE;
        data['x-app-version'] = process.env.APP_VERSION;
        data['x-timezone'] = app_config_1.appConfig.timezone;
        if (cookies.get('cookies_jwt_token')) {
            data['x-auth-token'] = cookies.get('cookies_jwt_token') || null;
        }
        else if (customHeaders && customHeaders['x-auth-token']) {
            data['x-auth-token'] = customHeaders['x-auth-token'];
        }
        if (((_a = process.env.SIGNATURE_VERSION) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'V2' ||
            ((_b = process.env.SIGNATURE_VERSION) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'V3') {
            data['x-signature-version'] = process.env.SIGNATURE_VERSION;
        }
        data = lodash_1.default.extend({}, data, customHeaders);
        return data;
    };
    return APIService;
}());
exports.api_service = new APIService();
